import { ChangeEventHandler, useCallback, useEffect } from "react";
import MuiTextField from "@mui/material/TextField";
import { fieldToTextField, TextFieldProps } from "formik-mui";
import { isNil } from "lodash-es";

type Props = { decimalScale: number } & TextFieldProps;

export function DecimalScaleTextField(props: Props) {
  const { decimalScale, ...remainingProps } = props;

  if (isNil(decimalScale)) {
    throw new Error(
      "Warning, no decimalScale provided. This is missing in Material-UI but it is required so provide 'decimalScale' to prevent weir behaviour"
    );
  }

  const {
    form: { setFieldValue },
    field: { name, value },
  } = props;

  // set initial value scale
  useEffect(() => {
    setFieldValue(name, !isNil(value) ? formatValue(value, decimalScale) : "");
  }, []);

  const onChangeCallback = useCallback(
    // TODO: this could be better typed
    (event: any) => {
      const { value } = event.target;
      setFieldValue(name, value ? formatValue(value, decimalScale) : "");
    },
    [setFieldValue, name, decimalScale]
  );

  function formatValue(value: number, decimalScale: number) {
    const scale = Math.pow(10, decimalScale);
    return Math.trunc(value * scale) / scale;
  }

  return <MuiTextField {...fieldToTextField(remainingProps)} onChange={onChangeCallback} />;
}
